import React from 'react'

import { Helmet } from 'react-helmet'

import WoordkunstComponent from '../components/woordkunst-component'
import './woordkunst.css'

const Woordkunst = (props) => {
  return (
    <div className="woordkunst-container10">
      <Helmet>
        <title>Woordkunst - Schrijf je vrij</title>
        <meta property="og:title" content="Woordkunst - Schrijf je vrij" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1>
        <span>Woordkunst</span>
        <br></br>
      </h1>
      <span className="woordkunst-text13">Gedichten en Haiku&apos;s</span>
      <div className="woordkunst-gallery1">
        <div className="woordkunst-container11">
          <div className="woordkunst-container12">
            <div className="woordkunst-container13">
              <h1 className="woordkunst-text14"> Ken je dat gevoel?</h1>
              <span className="woordkunst-text15">
                <span> ken je dat gevoel? ​</span>
                <br></br>
                <span>
                  {' '}
                  dat je zoveel van iemand houdt
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  dat het bijna pijn doet
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  omdat je niet kan bevatten
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  dat er zoveel liefde kan bestaan
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  een liefde die zachter maakt
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  een zwakke kant naar boven haalt
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  een geheel nieuwe dimensie die zich aandient
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  afhankelijk durven zijn
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  en kwetsbaar, zo kwetsbaar
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  elke minuut van de dag
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  bij haar willen zijn
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  naar haar kijken, haar liefkozen
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  nooit meer van haar zijde wijken
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  en steeds maar weer zeggen
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span>
                  {' '}
                  ik hou van jou
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <span> ken je dat gevoel?</span>
              </span>
            </div>
            <img
              alt="image"
              src="https://play.teleporthq.io/static/svg/default-img.svg"
              className="woordkunst-image1"
            />
          </div>
        </div>
        <div className="woordkunst-container14">
          <div className="woordkunst-container15">
            <span className="woordkunst-text49">
              <span>ik loop naar haar toe</span>
              <br></br>
              <span>ze begroet me met geloei</span>
              <br></br>
              <span>en ik zeg: &apos;hi koe</span>
              <br></br>
            </span>
          </div>
        </div>
        <div className="woordkunst-container16">
          <div className="woordkunst-container17">
            <h1 className="woordkunst-text56">Project Title</h1>
            <span className="woordkunst-text57">
              <span>Lorem ipsum dolor sit amet</span>
            </span>
          </div>
        </div>
        <div className="woordkunst-container18">
          <div className="woordkunst-container19">
            <h1 className="woordkunst-text59">Project Title</h1>
            <p className="woordkunst-text60">
              <span>Lorem ipsum dolor sit amet</span>
            </p>
          </div>
        </div>
        <div className="woordkunst-container20">
          <div className="woordkunst-container21">
            <h1 className="woordkunst-text62">Project Title</h1>
            <span className="woordkunst-text63">
              <span>Lorem ipsum dolor sit amet</span>
            </span>
          </div>
        </div>
      </div>
      <div className="woordkunst-gallery2">
        <WoordkunstComponent
          text="ik loop naar haar toe \\\\ ze begroet me met geloei  en ik zeg: 'hi koe'"
          title=" "
        ></WoordkunstComponent>
        <div className="woordkunst-container22">
          <div className="woordkunst-container23">
            <span className="woordkunst-text65">
              <span>ik loop naar haar toe</span>
              <br></br>
              <span>ze begroet me met geloei</span>
              <br></br>
              <span>en ik zeg: &apos;hi koe</span>
              <br></br>
            </span>
          </div>
        </div>
        <div className="woordkunst-container24">
          <div className="woordkunst-container25">
            <h1 className="woordkunst-text72">Project Title</h1>
            <span className="woordkunst-text73">
              <span>Lorem ipsum dolor sit amet</span>
            </span>
          </div>
        </div>
        <div className="woordkunst-container26">
          <div className="woordkunst-container27">
            <h1 className="woordkunst-text75">Project Title</h1>
            <span className="woordkunst-text76">
              <span>Lorem ipsum dolor sit amet</span>
            </span>
          </div>
        </div>
        <div className="woordkunst-container28">
          <div className="woordkunst-container29">
            <h1 className="woordkunst-text78">Project Title</h1>
            <p className="woordkunst-text79">
              <span>Lorem ipsum dolor sit amet</span>
            </p>
          </div>
        </div>
        <div className="woordkunst-container30">
          <div className="woordkunst-container31">
            <h1 className="woordkunst-text81">Project Title</h1>
            <span className="woordkunst-text82">
              <span>Lorem ipsum dolor sit amet</span>
            </span>
          </div>
        </div>
      </div>
      <img
        alt="image"
        src="https://play.teleporthq.io/static/svg/placeholders/no-image.svg"
        className="woordkunst-image2"
      />
    </div>
  )
}

export default Woordkunst
